import React, { useEffect, useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BulkOrder from "./BulkOrder";
import ConfirmationPrompt from "./ConfirmationPrompt";
import DoctorsAssignmentModal from "./DoctorsAssignmentModal";
import Engagements from "./Engagements";
import { CheckCircleOutlined } from "@ant-design/icons";
import CancelOrder from "./CancelOrder";
import MarkAsDelivered from "./MarkAsDelivered";
import UpdateWarehouseAndMarkShipped from "./UpdateWarehouseAndMarkShipped";
import VoidOrder from "./VoidOrder";
import RTOVoidOrder from "./RTOVoidOrder";
import SendToDispatch from "./SendToDispatch";
import { canNotMarkStatusProgress } from "modules/utilities/utility";
import { useDoctors, useMarkORderInProgress } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import Prescription from "./Prescription";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Popconfirm } from "antd";
import ClinicAssignment from "./ClinicAssignment";
import ReturnOrderButton from "./ReturnRequestButton";
import RTOReattempt from "./RTOReattempt";
import CancelFullfilment from "./CancelFullfilment";

const buttonStyle =
  "border border-primary rounded-circle p-1 d-flex align-items-center justify-content-center";

function CustomComponent({
  name,
  order,
  status,
  isBulk,
  userId,
  orderId,
  currentId,
  buttonText,
  isSingleOrder,
  prescriptions,
  prescriptionsData,
  isSubscriptionOrder,
  customer,
}) {
  const { orderInProgress } = useMarkORderInProgress();
  const [dispatch, setDispatch] = useState(["shipped", "delivered", "shipping_pending", "void"].includes(status) || !prescriptionsData);
  const [subscribe, setSubscribe] = useState();
  const [subscription, setSubscription] = useState(isSubscriptionOrder);
  const [bulkOrder, setBulkOrder] = useState();
  const [singleOrder, setSingleOrder] = useState();
  const [resync, setResync] = useState();
  const [downloadPrescription, setDownloadPrescription] = useState(1);
  const [form, setForm] = useState(name);
  const [trigger, setTrigger] = useState(["hover", "focus"]);
  const [showPopover, setShowPopover] = useState(false);
  const buttonRef = useRef(null);
  const [isOrderSingle, setOrderSingle] = useState(isSingleOrder);

  const { fetchAssignedDoctorsData, fetchAvailableDoctorsData } = useDoctors();

  useEffect(() => {
    setSubscribe(true);
    setBulkOrder(!isBulk);
    setSingleOrder(true);
    setResync(true);
  }, [status, isBulk]);

  //commented for reference, due to api call have been shifted.
  // useEffect(() => {
  //   fetchAssignedDoctorsData(orderId);
  //   fetchAvailableDoctorsData();
  // }, [orderId]);

  const handleClick = () => {
    setShowPopover(!showPopover);
  };

  const handleClickOutside = (event) => {
    if (buttonRef.current && !buttonRef.current.contains(event.target)) {
      setShowPopover(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => { }, [orderId]);
  const prompt = {
    "Send To Dispatch": {
      message: (
        <p className="fw-bold">
          Are you sure you want to mark this order for shipping?
          <span className="text-warning">
            Note: This will cause the order to be sent to dispatch.
          </span>
        </p>
      ),
      btn: setDispatch,
      btnValue: dispatch,
    },
    "as single order": {
      message: (
        <p className="fw-bold">
          Are you sure you want to{" "}
          <span className={isOrderSingle ? "text-danger" : "text-success"}>
            {isOrderSingle ? "unmark " : "mark "}
          </span>
          this order as single order?
        </p>
      ),
      btn: setSingleOrder,
      btnValue: singleOrder,
    },
    "as subscription order": {
      message: (
        <p className="fw-bold">
          Are you sure you want to{" "}
          <span className={subscription ? "text-danger" : "text-success"}>
            {subscription ? "remove" : "mark"} this order as a subscription
          </span>
          ?
        </p>
      ),
      btn: setSubscribe,
      btnValue: subscribe,
    },
    "Resync Order": {
      message: (
        <p>
          This will cause the order information to be re-synced from Shopify and
          will reset the status of the order to{" "}
          <span className="text-danger">
            IN_PROGRESS / PENDING_PRESCRIPTION
          </span>
          . Any prescriptions written for this order will also be removed.
          Please confirm.
        </p>
      ),
      btn: setResync,
      btnValue: resync,
    },
    "Download Prescription": {
      message: <p>Download Prescription</p>,
      btn: setResync,
      btnValue: downloadPrescription,
    },
  };

  function popoverAndTooltip(name, isEnable = true) {
    return (
      <OverlayTrigger
        placement="top"
        trigger={trigger}
        rootClose={trigger === "click"}
        overlay={
          <Tooltip>
            {form === "as single order" &&
              (!isOrderSingle ? "Mark " : "Unmark ")}{" "}
            {form === "as subscription order" &&
              (!subscription ? "Mark " : "Unmark ")}{" "}
            <span className="fw-bold"> {form}</span>
          </Tooltip>
        }
      >
        <span
          className={`rounded-circle ${prompt[name].btnValue && isEnable ? `` : `disabled-action`
            }`}
          onClick={() => {
            if (prompt[name].btnValue && isEnable) {
              setForm(
                <ConfirmationPrompt
                  name={name}
                  orderId={orderId}
                  trigger={trigger}
                  setForm={setForm}
                  isDisable={isEnable}
                  btn={prompt[name].btn}
                  customerId={userId}
                  setTrigger={setTrigger}
                  subscription={subscription}
                  isOrderSingle={isOrderSingle}
                  setOrderSingle={setOrderSingle}
                  question={prompt[name].message}
                  setSubscription={setSubscription}
                />
              );
              setTrigger("click");
            }
          }}
        >
          {buttonText}
        </span>
      </OverlayTrigger>
    );
  }

  const checkSendToDispatch = () => {
    return !(
      ["shipped", "delivered", "shipping_pending", "void"].includes(status) ||
      !prescriptionsData
    );
  };

  switch (name) {
    case "Engagements":
      return (
        <div>
          <Engagements
            orderId={orderId}
            buttonStyle={buttonStyle}
            buttonText={buttonText}
          />
        </div>
      );
    case "Prescription":
      return (
        <OverlayTrigger
          placement="top"
          trigger={trigger}
          rootClose={trigger === "click"}
          overlay={
            <Tooltip>
              {prescriptionsData.length ? (
                ""
              ) : (
                <span className="fw-bold me-1">No</span>
              )}
              <span className="fw-bold">{form}</span>
            </Tooltip>
          }
        >
          <Prescription
            order={order}
            currentId={currentId}
            buttonStyle={buttonStyle}
            buttonText={buttonText}
            prescriptionsData={prescriptionsData}
            customer={customer}
          />
        </OverlayTrigger>
      );
    case "Assign Doctor":
      return (
        <DoctorsAssignmentModal
          orderId={orderId}
          name={name}
          orderStatus={order.status}
        />
      );
    case "Assign Clinic":
      return <ClinicAssignment />;
    case "Cancel Order":
      return (
        <CancelOrder
          buttonStyle={buttonStyle}
          buttonText={buttonText}
          currentId={currentId}
          isDisabled={false}
          name={name}
        />
      );
    case "Bulk Order":
      return (
        <OverlayTrigger
          placement="top"
          trigger={trigger}
          rootClose={trigger === "click"}
          overlay={
            <Tooltip>
              <span className="fw-bold "> {form} </span>
            </Tooltip>
          }
        >
          <span
            className={`rounded-circle ${isBulk && `disabled-action`}`}
            onClick={() => {
              bulkOrder &&
                (setTrigger("click"),
                  setForm(
                    <BulkOrder
                      isBulk={isBulk}
                      setForm={setForm}
                      setTrigger={setTrigger}
                      trigger={trigger}
                      name={name}
                      orderId={orderId}
                      setBulkOrder={setBulkOrder}
                    />
                  ));
            }}
          >
            <span className="mt-n1 bg-primary text-white d-flex justify-content-center align-items-center p-2 rounded-circle shadow" id="checkCircleOutlined">
              <CheckCircleOutlined />
            </span>
          </span>
        </OverlayTrigger>
      );

    case "Download Prescription":
      return popoverAndTooltip(name, 1);
    case "Send To Dispatch":
      return (
        <SendToDispatch
          order={order}
          buttonText={buttonText}
          prescriptionsData={prescriptionsData}
        />
      );
    case "as single order":
      return popoverAndTooltip(name);

    case "as subscription order":
      return popoverAndTooltip(name);

    case "Resync Order":
      return popoverAndTooltip(name);

    case "Update Warehouse & Mark Shipped":
      return (
        <UpdateWarehouseAndMarkShipped
          order={order}
          currentId={currentId}
          orderId={orderId}
          buttonStyle={buttonStyle}
          buttonText={buttonText}
          name={name}
        />
      );
    case "Mark as Delivered ":
      return (
        <MarkAsDelivered
          order={order}
          currentId={currentId}
          orderId={orderId}
          buttonStyle={buttonStyle}
          buttonText={buttonText}
          name={name}
        />
      );
    case "Void Order":
      return (
        <VoidOrder
          order={order}
          currentId={currentId}
          orderId={orderId}
          buttonStyle={buttonStyle}
          buttonText={buttonText}
          name={name}
        />
      );
    case "RTO Void Order":
      return (
        <RTOVoidOrder
          order={order}
          buttonStyle={buttonStyle}
          buttonText={buttonText}
          name={name}
        />
      );
    case "Assign Back":
      return (
        <Popconfirm
          title="Are you sure, you want to assign back?"
          onConfirm={() => {
            !canNotMarkStatusProgress.includes(order?.status) &&
              orderInProgress(orderId, toast);
          }}
        >
          <span>
            <OverlayTrigger
              overlay={
                <Tooltip
                  style={{ position: "fixed" }}
                  id="overlay-trigger-example"
                >
                  Assign Back
                </Tooltip>
              }
            >
              <span
                className={`${canNotMarkStatusProgress.includes(order?.status)
                  ? `disabled-action`
                  : ``
                  } mt-n1 bg-primary text-white d-flex justify-content-center align-items-center p-2 rounded-circle shadow`}
                  id="assign-back"
              >
                {buttonText}
              </span>
            </OverlayTrigger>
          </span>
        </Popconfirm>
      );
    case "Return Order":
      return (
        <ReturnOrderButton order={order} buttonText={buttonText} customer={customer} orderId={orderId} />
      );
    case 'Initiate RTO':
    case 'Reattempt Request': return (
      <RTOReattempt order={order} buttonText={buttonText} customer={customer} orderId={orderId} name={name} />
    )
    case "Cancel Fulfillment":
      return (
        <div>
          <CancelFullfilment order={order} buttonText={buttonText} />
        </div>
      );
  }
}

export default CustomComponent;
